<template>
  <BreadCrumb class="hidden sm:block" />
  <ExpertPage :entry="entry" />
</template>

<script>
import gql from 'graphql-tag';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import ExpertPage, { ExpertPageFragment } from '@/components/experts/ExpertPage';
import { stripLocale } from '@/utils/i18n';
import { useEntryPage } from '@/composables/useEntryPage';
import BreadCrumb from '@/components/layout/BreadCrumb';

export const ExpertPageQuery = gql`
  query ExpertPageQuery($site: String!, $uri: String!) {
    entry(section: "experts", site: [$site], uri: [$uri]) {
      ...EntryPageFragment
      ...ExpertPageFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }

  ${EntryPageFragment}
  ${ExpertPageFragment}
  ${SeomaticFragment}
`;

export default defineNuxtComponent({
  name: 'ExpertPageController',

  components: { ExpertPage, BreadCrumb },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const { locale } = useNuxtApp().$i18n;
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri };

    const { entry, seomatic } = await $craftRequest(ExpertPageQuery, variables);

    return { entry, seomatic };
  },
  created() {
    useEntryPage(this.entry, this.seomatic);
  },
});
</script>
